<ng-container *transloco="let t; read: 'reports'">
<drdp-container additionClasses="w-full mt-4">
  <drdp-container color="lightBlue">
    <form [formGroup]="searchForm">
      <div
        class="flex grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 p-2 gap-2 md:gap-3 flex-row content-center">
        @if (allAgenciesCheckbox) {
          <div class="col-span-1 flex items-center">
            <mat-checkbox color="primary" (change)="handleGlobal()"></mat-checkbox>
            <label class="inline">{{ t('filters.searchAllAgencies') }}</label>
          </div>
        }
        @if (displayCounty && hasSubfilters) {
          <div class="col-span-1 md:col-span-3 lg:col-span-4 flex flex-col lg:flex-row lg:items-center lg:gap-2">
            <span class="font-bold">{{ t('reportSearch.additionalFilters') }}</span>
            <mat-radio-group [attr.aria-label]="t('reportSearch.additionalFiltersAriaLabel')" class="flex items-center gap-3" formControlName="additionalFilter">
              <mat-radio-button [value]="subFilter.None" color="primary">{{ t('reportSearch.filterNone') }}</mat-radio-button>
              <mat-radio-button [value]="subFilter.Subgroups" color="primary">{{ t('reportSearch.filterSubgroups') }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }
        <div class="col-span-1 self-end">
          <drdp-select-state #stateSelect [initialStateId]="stateId.value" (state)="handleState($event)" [required]="requiredFields!.state"
            [clear]="clearDropdown">
          </drdp-select-state>
        </div>
        @if (!isGlobalAgencies) { 
          <div class="col-span-1 self-end">
            <drdp-select-agency #agencySelect (agency)="handleAgency($event)" [stateId]="stateId.value"
              [initialAgencyId]="multiSelectAgencies ? null : agencyId.value" [required]="requiredFields!.agency" [clear]="clearDropdown"
              [multiSelect]="multiSelectAgencies" [multiSelectInitVals]="multiSelectAgencies" [omitTestAgencies]="omitTestAgencies">
            </drdp-select-agency>
          </div>
        }
        <div class="col-span-1 self-end">
          <drdp-select-global-rating (ratingPeriod)="handleRatingPeriod($event)" [multiSelect]="multiSelectRatingPeriods"
            [required]="requiredFields!.globalRatingPeriod" [label]="ratingPeriodLabel"
            [clear]="clearDropdown" [showAll]="showAllRatingPeriods">
          </drdp-select-global-rating>
        </div>

        @if (!isGlobalAgencies) {
          @if (displaySite) {
            <div class="col-span-1 self-end">
              <drdp-select-site (site)="handleSite($event)" [agencyId]="multiSelectAgencies ? agencyIds.value : agencyId.value" [multiSelect]="multiSelectSites"
                [multiSelectInitVals]="false" [required]="requiredFields?.site || false" [clear]="clearDropdown">
              </drdp-select-site>
            </div>
          }

          @if (displayClassroom) {
            <div class="col-span-1 self-end">
              <drdp-filter-select #classroomSelect [label]="'shared.dropdowns.classroom' | transloco" [options]="classroomAssignments" [selectType]="select.Class"
                (onSelected)="handleClassroomAssignment($event)" [multiSelect]="multiSelectClassrooms"
                [required]="requiredFields?.classroom || false">
              </drdp-filter-select>
            </div>
          }
        }

        <!-- Only passing school year for 2025 reports because 2015 reports will only show 2015 age grades -->
        @if (displayAgeGroup) {
          <div class="col-span-1 self-end">
            <drdp-select-age-grade [label]="t('reportSearch.ageGroupLabel')" [initialageGradeId]="ageGradeInstrumentId.value"
              (ageGrade)="handleAgeGroupInstrument($event)" [stateId]="stateId.value" [multiSelect]="false"
              [required]="requiredFields!.ageGroup" [clear]="clearDropdown" [isPilot]="is2025"
              [schoolYearId]="is2025 ? schoolYearId : null">
            </drdp-select-age-grade>
          </div>
        }

        @if (hasSubfilters && !displayCounty) {
          <div [ngClass]="displaySite && displayClassroom ? 'col-span-2' : 'col-span-1'" class="self-end flex flex-col">
            <div>
              <span class="font-bold">{{ t('reportSearch.additionalFilters') }}</span>
            </div>
            <mat-radio-group [attr.aria-label]="t('reportSearch.additionalFiltersAriaLabel')" class="flex gap-3" formControlName="additionalFilter">
              <mat-radio-button [value]="subFilter.None" color="primary">{{ t('reportSearch.filterNone') }}</mat-radio-button>
              <mat-radio-button [value]="subFilter.Subgroups" color="primary">{{ t('reportSearch.filterSubgroups') }}</mat-radio-button>
            </mat-radio-group>
          </div>
        }

        @if (displayCounty && additionalFilter.value == subFilter.Subgroups) {
          <div class="col-span-1 self-end">
            <drdp-select-county (county)="handleCounty($event)" [stateId]="stateId.value" [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true" [clear]="clearDropdown" [label]="t('reportSearch.countyLabel')">
            </drdp-select-county>
          </div>
        }
      </div>
      @if (additionalFilter.value == subFilter.Subgroups) {
        <div
          class="flex grid grid-cols-1 grid-rows-2 md:grid-cols-2 lg:grid-cols-5 p-2 gap-2 md:gap-3 flex-row content-center pb-6">
          <div class="col-span-1 self-end">
            <drdp-date-picker
              [label]="t('reportSearch.dobStartLabel')"
              [initialDate]="dobStart.value"
              [placeholder]="t('reportSearch.dobStartPlaceholder')"
              [isReadOnly]="false"
              (emitDate)="handleDobStart($event)"
              >
            </drdp-date-picker>
          </div>
          <div class="col-span-1 self-end">
            <drdp-date-picker
              [label]="t('reportSearch.dobEndLabel')"
              [initialDate]="dobEnd.value"
              [placeholder]="t('reportSearch.dobEndPlaceholder')"
              [isReadOnly]="false"
              (emitDate)="handleDobEnd($event)"
              >
            </drdp-date-picker>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-gender
              [stateId]="stateId.value"
              [initialGenderIds]="gender.value"
              (gender)="handleGender($event)"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              >
            </drdp-select-gender>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-yes-no
              [label]="t('reportSearch.hispanicLabel')"
              [initialIds]="latino.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (optionSelected)="handleHispanic($event)"
              >
            </drdp-select-yes-no>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-race
              [label]="'shared.dropdowns.race' | transloco"
              [stateId]="stateId.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (race)="handleRace($event)"
              >
            </drdp-select-race>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-yes-no
              [label]="t('reportSearch.reducedMealsLabel')"
              [initialIds]="reducedLunch.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (optionSelected)="handleReducedLunch($event)"
              >
            </drdp-select-yes-no>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-iep-plan
              [label]="t('reportSearch.iepLabel')"
              [initialIds]="iep.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (optionSelected)="handleIep($event)"
              >
            </drdp-select-iep-plan>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-program-type
              [ageGradeId]="ageGradeInstrumentId.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (programType)="handleProgramType($event)"
              >
            </drdp-select-program-type>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-language
              [label]="t('reportSearch.homeLanguageLabel')"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (language)="handleLanguage($event)"
              >
            </drdp-select-language>
          </div>
          <div class="col-span-1 self-end">
            <drdp-select-yes-no
              [label]="t('reportSearch.eldLabel')"
              [initialIds]="eld.value"
              [multiSelect]="true" [showCheckAll]="showSubfilterCheckAll"
              [multiSelectInitVals]="true"
              [required]="false"
              (optionSelected)="handleEld($event)"
              >
            </drdp-select-yes-no>
          </div>
        </div>
      }
      <div class="hidden lg:block lg:col-span-3 xl:col-span-3 self-end"></div>
      <div class="flex flex-row gap-1.5 justify-end lg:col-span-2 xl:col-span-1 md:self-end xl:my-auto mt-2 md:mt-0">
        @if (displayActivitiesBankBtn) {
          <div class="col-span-1">
            <drdp-btn [disabled]="!searchForm.valid" type="button" (click)="search(true)">
              <span class="px-2">{{ t('reportSearch.activitiesBankReport') }}</span>
            </drdp-btn>
          </div>
        }
        <div class="col-span-1">
          <drdp-btn [disabled]="!searchForm.valid" type="submit">
            <span class="px-2" (click)="search()">{{ showReportBtnText }}</span>
          </drdp-btn>
        </div>
        @if (displayDownload) {
          <div class="col-span-1">
            @if (showLocale) {
              <drdp-btn type="button" [disabled]="!searchForm.valid || isDownloadDisabled"
                (click)="isDownloadMenuOpen = !isDownloadMenuOpen; isSecondaryBtnClick = false"
              [matMenuTriggerFor]="(searchForm.valid && !isDownloadDisabled) ? reportMenu : null">{{ downloadBtnText }}</drdp-btn>
            }
            @if (!showLocale) {
              <drdp-btn type="button" [disabled]="!searchForm.valid || isDownloadDisabled"
              (click)="downloadReport(languageService.activeId())">{{ downloadBtnText }}</drdp-btn>
            }
          </div>
        }
        @if (secondaryDownloadBtnText) {
          <div class="col-span-1">
            <drdp-btn type="button" [disabled]="!searchForm.valid" (click)="isDownloadMenuOpen = !isDownloadMenuOpen; isSecondaryBtnClick = true"
              [matMenuTriggerFor]="searchForm.valid ? reportMenu : null">{{ secondaryDownloadBtnText }}</drdp-btn>
          </div>
        }
        @if (displayClear) {
          <div class="col-span-1">
            <drdp-btn color="outline" (click)="clear()">{{ 'shared.actions.clear' | transloco }}</drdp-btn>
          </div>
        }
        <mat-menu #reportMenu="matMenu" [overlapTrigger]="false" [hasBackdrop]="false" (closed)="isDownloadMenuOpen = false">
          <div class="flex flex-col items-center">
            <drdp-btn additionalClasses="mt-2" (click)="downloadReport('en')">{{ t('reportSearch.downloadEnglish') }}</drdp-btn>
            <drdp-btn additionalClasses="mt-2" (click)="downloadReport('es')">{{ t('reportSearch.downloadSpanish') }}</drdp-btn>
          </div>
        </mat-menu>
      </div>
    </form>
  </drdp-container>
</drdp-container>
</ng-container>
